// Password rules — keep in sync with api/util/password.js
export const PASSWORD_RULES = [
  { test: (p) => p.length >= 8, text: "At least 8 characters" },
  { test: (p) => /[A-Z]/.test(p), text: "An uppercase letter" },
  { test: (p) => /[a-z]/.test(p), text: "A lowercase letter" },
  { test: (p) => /\d/.test(p), text: "A number" },
  { test: (p) => /[^A-Za-z0-9]/.test(p), text: "A special character (e.g. ! @ # $)" },
]

export const passwordOk = (p) => PASSWORD_RULES.every((r) => r.test(p))
